const venues = (state = {}, action) => {
    switch (action.type) {
        case 'VENUES_DATA_LOADED' : 
            return{
            ...state,
            venueData : action.payload
            }
        default:
            return state
        }
  }
  export default venues